import TimeAgo from "javascript-time-ago";
import sv from "javascript-time-ago/locale/sv";

TimeAgo.addLocale(sv);

export default new TimeAgo("sv");
